import { useEffect } from 'react';
export function useModal(open) {
    useEffect(function () {
        var body = document.body;
        if (open) {
            body.style.top = "-".concat(window.scrollY, "px");
            body.classList.add('modal-open');
        }
        else {
            var offset = -parseInt(body.style.top || '0', 10);
            body.classList.remove('modal-open');
            body.style.top = '';
            window.scrollTo(0, offset);
        }
        return function () { };
    }, [open]);
}
//# sourceMappingURL=useModal.js.map